import { render } from "./fav.vue?vue&type=template&id=f2cbc526&scoped=true"
import script from "./fav.vue?vue&type=script&lang=js"
export * from "./fav.vue?vue&type=script&lang=js"

import "./fav.vue?vue&type=style&index=0&id=f2cbc526&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2cbc526"]])

export default __exports__